module.exports = __webpack_public_path__ + "static/conduccion---panel-de-control-18a70a79264b11da24f14bbbffc9d4a5.jpg";